export interface ErrorRecoveryProps {
  error: Error | { message: string }
}

export function ErrorRecovery({ error }: ErrorRecoveryProps) {
  const errorMessage =
    error instanceof Error ? error.message : error.message || "An unexpected error occurred"
  const stack = error instanceof Error ? error.stack : null

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-my-rituality-bg px-6">
      <div className="w-full max-w-lg">
        <hr className="border-white/10 mb-10" />

        <h1 className="text-2xl font-semibold tracking-tight text-chat-text">
          Oops! Something unexpected happened.
        </h1>

        <p className="mt-3 text-sm leading-relaxed text-chat-text/50">
          We are looking into it. Please refresh the page or try again in a moment.
        </p>

        <div className="mt-6 rounded-xl border border-chat-text/8 bg-chat-text/3 p-4">
          <p className="text-sm font-mono text-chat-text/45">{errorMessage}</p>

          {stack && (
            <pre className="mt-3 text-xs text-white/40 overflow-x-auto max-h-40 overflow-y-auto leading-relaxed">
              {stack}
            </pre>
          )}
        </div>

        <div className="mt-8 flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 rounded-full h-11 px-5 text-sm font-semibold bg-chat-text text-connect-cream-text hover:bg-connect-cream-hover transition-colors cursor-pointer w-[180px] justify-center"
          >
            Try Again
          </button>

          <button
            type="button"
            onClick={() => {
              window.location.href = "/"
            }}
            className="inline-flex items-center gap-2 rounded-full border border-chat-text/30 h-11 px-5 text-sm font-semibold text-chat-text/60 hover:bg-white/5 transition-colors cursor-pointer w-[180px] justify-center"
          >
            Go Home
          </button>
        </div>

        <hr className="border-white/10 mt-10" />
      </div>
    </div>
  )
}
